/**
 * Guest Guard
 * Ensures user is NOT authenticated (for login/signup pages)
 * Redirects authenticated users to home page
 * Uses the local JWT token stored in localStorage
 */

import { redirect } from '@tanstack/react-router';
// import { authService } from '../../services/auth.service';
import { getAccessToken } from '../../utils/auth-token';

/**
 * Check if user is a guest (not authenticated)
 * Used in route beforeLoad hooks for auth pages (login, signup)
 * Redirects to /home if already authenticated
 *
 * @throws Error if user is already authenticated
 */
export const requireGuest = async () => {
  const currentWindow = globalThis.window;
  if (!currentWindow) {
    return;
  }

  const searchParams = new URLSearchParams(currentWindow.location.search);
  const hashParams = new URLSearchParams(currentWindow.location.hash.replace(/^#/, ''));
  const getParam = (key: string) => searchParams.get(key) ?? hashParams.get(key);
  const recoveryType = getParam('type');
  const recoveryToken = getParam('access_token') ?? getParam('code');

  if (recoveryType === 'recovery' || recoveryToken) {
    console.log('[requireGuest] Recovery flow detected, skipping guest redirect');
    return;
  }

  // Check for active token
  const token = getAccessToken();

  // If token exists, user is authenticated
  if (token) {
    console.log('[requireGuest] Active session found, redirecting to /home');
    throw redirect({ to: '/home' });
  }

  console.log('[requireGuest] No session, allowing access to auth page');
};
